import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useEncounterCreationGate } from "../../hooks/use-encounter-creation-gate";
import {
  PatientInsurance,
  PatientInsuranceControllerApi,
} from "../../services";
import { PaginatedPayload } from "../../types/sdk-types";
import { getConfigObject } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
export const useGetInsuranceByPatientId = (
  uuid?: string
): UseQueryResult<
  PaginatedPayload<PatientInsurance> | undefined,
  AxiosError
> => {
  const skip = useEncounterCreationGate();
  return useQuery({
    queryKey: ["get-insurance-by-patient-id", uuid],
    enabled: !!uuid && !skip,
    refetchOnWindowFocus: false,

    queryFn: async () =>
      new PatientInsuranceControllerApi(getConfigObject())
        .getPatientInsurance(uuid as string)
        .then(
          (res) =>
            res?.data?.data as PaginatedPayload<PatientInsurance> | undefined
        ),
  });
};
